<template>
	<div>
		<div class="cl-theme ftr-1-25 ftw600">
			{{$t('common.memberprogressReport',{name:studentInfo.user_info.nickname})}}
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('studentsCom.courseContent')}}
		</div>
		<div class="mt-1 flex alcenter ftw600">
			<div style="width: 80px;">{{$t('studentsCom.keyCourse')}}:</div>
			<a-input :placeholder="$t('common.enter')" style="width: 220px;" v-model="info.educational_highlights" ></a-input>
		</div>
		<div class="mt-1 flex alcenter ftw600">
			<div style="width: 80px;">{{$t('studentsCom.learningObjectives')}}:</div>
			<a-input :placeholder="$t('common.enter')" style="width: 220px;" v-model="info.learning_objectives" ></a-input>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.classroomReport4')}}
		</div>
		<div class="">
			<div class="mt-1 flex ftw600">
				<div style="width: 80px;">{{$t('teacherIndex.classroomReport5')}}</div>
				<div>
					<div class="flex alcenter">
						<a-input :placeholder="$t('myStudents.scoreRange')" v-model="info.score_concentration" style="width: 150px;" ></a-input>
						<div class="ml16" :class="getColor(getScore(info.score_concentration))">
							{{getScore(info.score_concentration)}}
						</div>
					</div>
					<div class="flex alcenter mt-2">
						<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_concentration"
						 @dropdownVisibleChange="handleSelect('5')">
							<a-select-option :value="''" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
								{{item.copywrite}}
							</a-select-option>
						</a-select>
						<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_concentration" ></a-input>
					</div>
				</div>
			</div>
			<div class="mt-1 flex ftw600">
				<div style="width: 80px;">{{$t('teacherIndex.classroomReport6')}}</div>
				<div>
					<div class="flex alcenter">
						<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_degree_mastery" ></a-input>
						<div class="ml16" :class="getColor(getScore(info.score_degree_mastery))">
							{{getScore(info.score_degree_mastery)}}
						</div>
					</div>
					<div class="flex alcenter mt-2">
						<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_degree_mastery" 
						 @dropdownVisibleChange="handleSelect('6')">
							<a-select-option :value="''" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
								{{item.copywrite}}
							</a-select-option>
						</a-select>
						<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_degree_mastery" ></a-input>
					</div>
				</div>
			</div>
			<div class="mt-1 flex ftw600">
				<div style="width: 80px;">{{$t('teacherIndex.classroomReport7')}}</div>
				<div>
					<div class="flex alcenter">
						<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_degree_participation"></a-input>
						<div class="ml16" :class="getColor(getScore(info.score_degree_participation))">
							{{getScore(info.score_degree_participation)}}
						</div>
					</div>
					<div class="flex alcenter mt-2">
						<a-select style="width: 220px;"  class="ft14" size="large" v-model="info.remark_degree_participation" 
						 @dropdownVisibleChange="handleSelect('7')"  >
							<a-select-option :value="''" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
								{{item.copywrite}}
							</a-select-option>
						</a-select>
						<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_degree_participation"></a-input>
					</div>
				</div>
			</div>
			<div class="mt-1 flex ftw600">
				<div style="width: 80px;">{{$t('teacherIndex.classroomReport8')}}</div>
				<div>
					<div class="flex alcenter">
						<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_range_advancement" ></a-input>
						<div class="ml16" :class="getColor(getScore(info.score_range_advancement))">
							{{getScore(info.score_range_advancement)}}
						</div>
					</div>
					<div class="flex alcenter mt-2">
						<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_range_advancement" 
						 @dropdownVisibleChange="handleSelect('8')" >
							<a-select-option :value="''" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
								{{item.copywrite}}
							</a-select-option>
						</a-select>
						<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;"  v-model="info.remark_range_advancement" ></a-input>
					</div>
				</div>
			</div>
			<div class="mt-1 flex ftw600">
				<div style="width: 80px;">{{$t('teacherIndex.classroomReport9')}}</div>
				<div>
					<div class="flex alcenter">
						<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_assignment" ></a-input>
						<div class="ml16" :class="getColor(getScore(info.score_assignment))">
							{{getScore(info.score_assignment)}}
						</div>
					</div>
					<div class="flex alcenter mt-2">
						<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_assignment" 
						 @dropdownVisibleChange="handleSelect('9')" >
							<a-select-option :value="''" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
								{{item.copywrite}}
							</a-select-option>
						</a-select>
						<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_assignment" ></a-input>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.progressReport1')}}
		</div>
		<div class="mt-3 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport2')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_time_management_planning" ></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_time_management_planning))">
						{{getScore(info.score_time_management_planning)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_time_management_planning" 
						 @dropdownVisibleChange="handleSelect('10')" >
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_time_management_planning" ></a-input>
				</div>
			</div>
		</div>
		<div class="mt-1 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport3')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_savvy" ></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_savvy))">
						{{getScore(info.score_savvy)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_savvy" 
						 @dropdownVisibleChange="handleSelect('11')" >
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_savvy"  ></a-input>
				</div>
			</div>
		</div>
		<div class="mt-1 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport4')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_answering_speed"></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_answering_speed))">
						{{getScore(info.score_answering_speed)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_answering_speed" 
						 @dropdownVisibleChange="handleSelect('12')" >
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;"  v-model="info.remark_answering_speed" ></a-input>
				</div>
			</div>
		</div>
		<div class="mt-1 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport5')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_accuracy_rating"></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_accuracy_rating))">
						{{getScore(info.score_accuracy_rating)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_accuracy_rating" 
						 @dropdownVisibleChange="handleSelect('13')" >
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_accuracy_rating"></a-input>
				</div>
			</div>
		</div>
		<div class="mt-1 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport6')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_strategy" ></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_strategy))">
						{{getScore(info.score_strategy)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_strategy" 
						 @dropdownVisibleChange="handleSelect('14')" >
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_strategy"></a-input>
				</div>
			</div>
		</div>
		<div class="mt-1 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport7')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_stress_management" ></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_stress_management))">
						{{getScore(info.score_stress_management)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_stress_management" 
						 @dropdownVisibleChange="handleSelect('15')">
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;"  v-model="info.remark_stress_management"  ></a-input>
				</div>
			</div>
		</div>
		<div class="mt-1 flex ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.progressReport8')}}</div>
			<div>
				<div class="flex alcenter">
					<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_inspection_strategy" ></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_inspection_strategy))">
						{{getScore(info.score_inspection_strategy)}}
					</div>
				</div>
				<div class="flex alcenter mt-2">
					<a-select style="width: 220px;" class="ft14" size="large" v-model="info.remark_inspection_strategy" 
						 @dropdownVisibleChange="handleSelect('16')" >
						<a-select-option :value="''" >
							{{$t('common.select')}}
						</a-select-option>
						<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
							{{item.copywrite}}
						</a-select-option>
					</a-select>
					<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.remark_inspection_strategy"></a-input>
				</div>
			</div>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.classroomReport11')}}
		</div>
		<div class="flex alcenter">
			<div style="width: 80px;" class="ftw600" >{{$t('teacherIndex.progressReport9')}}:</div>
			<a-select style="width: 220px;" class="ft14" size="large" v-model="info.short_commentary" 
						 @dropdownVisibleChange="handleSelect('17')" >
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.short_commentary" ></a-input>
		</div>
		<div class="flex alcenter mt-2">
			<div style="width: 80px;" class="ftw600" >{{$t('teacherIndex.progressReport10')}}:</div>
			<a-select style="width: 220px;" class="ft14" size="large" v-model="info.learning_advice" 
						 @dropdownVisibleChange="handleSelect('18')">
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.learning_advice"></a-input>
		</div>
		<div class="flex alcenter mt-2">
			<div style="width: 80px;" class="ftw600" >{{$t('teacherIndex.progressReport11')}}:</div>
			<a-select style="width: 220px;" class="ft14" size="large" v-model="info.next_target" 
						 @dropdownVisibleChange="handleSelect('19')" >
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.next_target" ></a-input>
		</div>
		<div class="flex alcenter mt-2">
			<div style="width: 80px;" class="ftw600" >{{$t('studentsCom.overallEvaluation')}}:</div>
			<a-input :placeholder="$t('myStudents.scoreRange')" style="width: 150px;" v-model="info.score_overall" ></a-input>
			<div class="ml16" :class="getColor(getScore(info.score_overall))">
				{{getScore(info.score_overall)}}
			</div>
		</div>
		
		<div class="flex alcenter mt-2">
			<div class=" cl-theme ftw600">
				{{$t('studentsCom.supportYou')}}
			</div>
			<a-select style="width: 220px;" class="ft14" size="large" v-model="info.support" 
						 @dropdownVisibleChange="handleSelect('4')" >
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in selectListOptions">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.support"></a-input>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.progressReport12')}}
		</div>
		
		
		<div class="flex mt-2">
			<div class="py-1 px-3 clickAct" v-for="(item,index) in formTeacherC"
			@click="changeClassType(item) "
			:class="formTeacherTypeId==item.id?'bg-theme border-theme cl-w':'bg-F3F3F3 border-gray'">
				{{item.name}}
			</div>
		</div>
		<div class="flex alcenter">
			<div class="" style="width: 150px;">
			</div>
			
			<div class="mt-3">
				<!-- 正式堂 -->
				{{$t('teacherVue.formalClasses')}}
			</div>
		</div>
		<div v-for="(it,ind) in formTeacherItem" :key="ind">
			<div class="mt-2 row ft14 flex alcenter clickAct">
				<div class="" style="width: 150px;">
					{{it.name}}
				</div>
				<div class="col-md py-2 flex wrap ">
					<div v-for="(itChild,indChild) in it.teacherCourse">
						<div class="border-gray br8 wid-fit p-1 ml5 mt-1" style="width: 100px;" v-if="indChild>0"
						@click="selectTeacherCourse(itChild,it.name)">
							<div class="ftw600">
								{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
							</div>
							<div class="cl-info ft10">
								<!-- {{itChild.quantity}}堂50分鐘課 -->
								{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
							</div>
							<div class="border-theme py-0 px-3 cl-theme ft10 wid-fit">
								{{itChild.discount}}% off
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		
		<div v-if="JSON.stringify(select_course_info) !='{}'">
			<div class="mt-4 flex">
				<span style="width: 70px;" >
					{{$t('cashDesk.subject')}}:
				</span>
				{{select_course_info.name}}
			</div>
			<div class="mt-2 flex">
				<span style="width: 70px;" >
					{{$t('myStudents.coursePackage')}}:
				</span>
				{{getCurrency()}}{{convertCurrency(select_course_info.once_price)}} * {{$t('teacherVue.formalClassTime',{number:select_course_info.quantity})}}
			</div>
			<div class="mt-2 flex">
				<span style="width: 70px;" >
					{{$t('userCenter.timeLimit')}}:
				</span>
				<a-select style="width: 220px;" size="large" v-model="effective_time" >
					<a-select-option :value="720" >
						12{{$t('common.hour')}}
					</a-select-option>
					<a-select-option :value="1440" >
						24{{$t('common.hour')}}
					</a-select-option>
					<a-select-option :value="2160" >
						36{{$t('common.hour')}}
					</a-select-option>
					<a-select-option :value="2880" >
						48{{$t('common.hour')}}
					</a-select-option>
					<a-select-option :value="4320" >
						72{{$t('common.hour')}}
					</a-select-option>
				</a-select>
			</div>
		</div>
		
		<div class="mt-4">
			<div class="btn btn-theme" @click="editUserReportNew()">
				{{$t('becomeTeacher.submit')}}
			</div>
			<div class="btn btn-outline-gray ml15" @click="navBack()">
				{{$t('common.back')}}
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				formTeacherC:[],
				formTeacherTypeId:0,
				formTeacherItem:[],
				
				studentInfo:{},
				info:{
					user_id:0,
					educational_highlights:'',//课程重点
					learning_objectives:'',//学习目标
					score_concentration:'',//专注力评分
					score_degree_mastery:'',//掌握度评分
					score_degree_participation:'',//参与度评分
					score_range_advancement:'',//进步幅度评分
					score_assignment:'',//作业/测验评分
					remark_concentration:'',//专注力备注
					remark_degree_mastery:'',//掌握度备注
					remark_degree_participation:'',//参与度备注
					remark_range_advancement:'',//进步幅度备注
					remark_assignment:'',//作业/测验备注
					score_time_management_planning:'',//时间管理规划评分
					remark_time_management_planning:'',//时间管理规划备注
					score_savvy:'',//审题理解能力评分
					remark_savvy:'',//审题理解能力备注
					score_answering_speed:'',//答题速度与效率评分
					remark_answering_speed:'',//答题速度与效率备注
					score_accuracy_rating:'',//准确度与细心程度评分
					remark_accuracy_rating:'',//准确度与细心程度备注
					score_strategy:'',//解题策略与技巧评分
					remark_strategy:'',//解题策略与技巧备注
					score_stress_management:'',//压力管理与心态调整评分
					remark_stress_management:'',//压力管理与心态调整备注
					score_inspection_strategy:'',//检查与复查策略评分
					remark_inspection_strategy:'',//检查与复查策略备注
					short_commentary:'',//短评
					learning_advice:'',//学习建议
					score_overall:'',//总评分
					support:'',//鼓励
					next_target:'',//下个目标
				},
				selectList:[],
				selectListOptions:[],
				class_highlights_list:[],//课堂亮点 预设字段
				learning_advice_list:[],//学习建议 预设字段
				next_lesson_preview_list:[] ,//下堂预告 预设字段
				support_list:[],//鼓励 预设字段
				
				select_course_info:{},//选中的建议课包信息
				effective_time:720,//課包優惠時間
				
			}
		},
		async created() {
			this.studentInfo = JSON.parse(this.$route.query.item)
			this.info.user_id = this.studentInfo.user_id
			console.log("学生信息",this.studentInfo);
			let arr = await this.informationIntegration(['presetCopywrit'])
			this.selectList = arr.list.presetCopywrit.list
			this.getDetails()
			this.openSend()
		},
		methods:{
			selectTeacherCourse(item,name){
				this.select_course_info = item
				this.select_course_info.name = name
				// console.log("item",item,name);
			},
			getFutureTimeInMinutes(x) {
			    // 获取当前时间
			    const now = new Date();
			    
			    // 计算未来的时间
			    now.setMinutes(now.getMinutes() + x);
			    
			    // 格式化日期和时间
			    const year = now.getFullYear();
			    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需加1
			    const day = String(now.getDate()).padStart(2, '0');
			    const hours = String(now.getHours()).padStart(2, '0');
			    const minutes = String(now.getMinutes()).padStart(2, '0');
			    const seconds = String(now.getSeconds()).padStart(2, '0');
			
			    // 返回格式化的字符串
			    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			// 限时优惠新增，即老师给学生推荐的课包
			teacherCourseSaleUpdate(){
				this.$http.api('teacher/user/teacherCourseSaleUpdate',{
					user_id:this.info.user_id,
					teacher_course_id:this.select_course_info.id,
					price:this.select_course_info.price,
					finish_time:this.getFutureTimeInMinutes(this.effective_time),
				}).then(res=>{
					
				})
			},
			
			handleSelect(num){
				this.selectListOptions = []
				
				this.selectList.forEach((item,index)=>{
					if(item.type==num){
						this.selectListOptions.push(item)
					}
					
				})
			},
			getScore(score){
				if(score==''){
					return ' '
				}
				let num = Number(score)
				if(num<=50){
					return 'C-'
				}else if(num>50&&num<=55){
					return 'C'
				}else if(num>55&&num<=60){
					return 'C+'
				}else if(num>60&&num<=65){
					return 'B-'
				}else if(num>65&&num<=70){
					return 'B'
				}else if(num>70&&num<=75){
					return 'B+'
				}else if(num>75&&num<=80){
					return 'A-'
				}else if(num>80&&num<=90){
					return 'A'
				}else if(num>90){
					return 'A+'
				}
			},
			getScoreTotal(){
				let num
				num = Number(this.info.score_concentration)+Number(this.info.score_degree_mastery)+Number(this.info.score_degree_participation)
				+Number(this.info.score_range_advancement)+Number(this.info.score_assignment)
				this.info.score_average = num/5
				return this.info.score_average ? this.getScore(this.info.score_average):''
			},
			getColor(str){
				if(str.includes('A')){
					return 'cl-theme'
				}else if(str.includes('B')){
					return 'cl-b'
				}else{
					return 'cl-c'
				}
			},
			editUserReportNew(){
				this.$confirm({
					title: this.$t('common.confirmSubmit'),
					content: this.$t('common.cancelSubmitText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/user/editUserReportNew',this.info).then(res=>{
							this.teacherCourseSaleUpdate()
							this.$message.success(this.$t('common.operationSuccessful'),2,()=>{
								this.$router.back()
							})
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
			},
			getDetails(){
				this.$http.api('teacher/user/userReportDetailNew',{user_id:this.info.user_id}).then(res=>{
					if(res.info){
						this.info = res.info
					}
				})
			},
			async openSend(teacherCourse){
				console.log("------teacherInfo",this.teacherInfo);
				await this.$http.api('course/classifyList',{
					teacherCourse:this.teacherInfo.id,
					includeCourse:1,//返回老师课程信息
				}).then(res=>{
					this.formTeacherC=res.list
					this.formTeacherTypeId = res.list[0].id
					// this.formTeacherTypeName =res.list[0].name
					this.formTeacherItem = res.list[0].course
					// this.teacher_course_id = res.list[0].course[0].teacherCourse[0].id
					// this.formTeacherItem.forEach((item,index)=>{
					// 	if(item.teacherCourseDelay.length!=0){
					// 		this.showPrice = true
					// 	}
					// })
					
					
				})
			},
			navBack(){
				this.$router.back()
			}
		}
	}
</script>

<style>
	.cl-b{
		color: #92D050;
	}
	.cl-c{
		color: #FFC000;
	}
</style>